module.exports = __webpack_public_path__ + "img/ico-search-query-1.502424b9.png";